import { useReactiveVar } from '@apollo/client';
import { conversationsVar, selectedConversationVar, showingChatBoxVar } from 'apollo/store';
import { IconMessageCircle } from 'components/icons';
import { useAuthenticationContext } from 'components/providers/authentication-provider';
import { SITE_MAP } from 'globalConstants';
import { STATUS } from 'graphql/main/mutations';
import { Conversation } from 'graphql/main/queries';
import { filter, find, includes, isEqual, map } from 'lodash';
import { useRouter } from 'next/router';
import queryString from 'query-string';
import { useFriendStatus } from '..';

const ChatButton = () => {
  const router = useRouter();
  const { asPath, push } = router;
  const { user, friendStatus } = useFriendStatus();
  const { currentUser } = useAuthenticationContext();
  const conversations = useReactiveVar(conversationsVar);
  const { status } = friendStatus ?? {};

  const clickMessage = async () => {
    if (!currentUser) {
      push({
        pathname: `/${SITE_MAP.SIGN_IN.INDEX}`,
        query: queryString.stringify({ redirect: asPath }, { encode: false }),
      });
    } else {
      const foundConversation = find(
        conversations,
        (conversation) =>
          !conversation.isGroup &&
          includes(
            map(conversation.participants, (participant) => participant.userId),
            currentUser?.id,
          ) &&
          includes(
            map(conversation.participants, (participant) => participant.userId),
            user?.id,
          ),
      );
      if (foundConversation) {
        selectedConversationVar(foundConversation);
      } else {
        const newConversation: Conversation = {
          name: user?.fullName,
          participants: [
            {
              userId: currentUser?.id,
              avatar: currentUser?.avatar,
              fullName: currentUser?.fullName,
            },
            {
              userId: user?.id,
              avatar: user?.avatar ?? undefined,
              fullName: user?.fullName,
            },
          ],
        };
        conversationsVar([
          newConversation,
          ...filter(conversations, (conversation) => Boolean(conversation.id)),
        ]);
        selectedConversationVar(newConversation);
      }
      showingChatBoxVar(true);
    }
  };

  return (
    <button
      id='chat-button'
      type='button'
      className={`${
        isEqual(status, STATUS.ACCEPTED)
          ? 'bg-primary text-paper hover:bg-primary-light'
          : 'bg-tertiary hover:bg-tertiary-light'
      } flex h-[38px] w-1/2 items-center justify-center space-x-[6px] rounded-[6px] font-[600] duration-[200ms] ease-in-out `}
      onClick={clickMessage}
    >
      <IconMessageCircle className='h-[22px] w-[22px]' />
      <span className='font-[600]'>Nhắn tin</span>
    </button>
  );
};

export default ChatButton;
